"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.argBlockCss = void 0;
const nano_theme_1 = require("nano-theme");
exports.argBlockCss = (0, nano_theme_1.rule)({
    pd: '4px 16px 8px',
    minW: '240px',
});
